export const popup = (name, url) => {
  const w = 600;
  const h = 800;
  const x = Math.max(window.screen.width / 2 - w / 2, 0);
  const y = Math.max(window.screen.height / 4 - h / 4, 0);

  const features = `menubar=no,toolbar=no,location=yes,resizable=yes,scrollbars=yes,status=yes,left=${x},top=${y},width=${w},height=${h}`;
  return window.open(url, name, features);
};
